import { render } from "./Evangelio.vue?vue&type=template&id=adf33004"
import script from "./Evangelio.vue?vue&type=script&lang=js"
export * from "./Evangelio.vue?vue&type=script&lang=js"

import exportComponent from "/Users/q/Documents/projects/religious-app/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__